module.exports = __webpack_public_path__ + "img/Paramount MWC.c07d20fc.png";